import React from "react";
import IntlMessage from '../../src/helpers/intlMessage';
import ConfiguracaoApi from '../../src/pages/configuracao/configuracao.api';
import { setUrlEditor, getUrlEditor, getFontePadrao, setFontePadrao } from '../../src/localStorage.util';

let url_editor = '';
let fonte_padrao = '';

async function getEditorUrl() {
	try {
		return await ConfiguracaoApi.getConfiguracaoEditor().then((config) => {
			url_editor = config.urlEditor;
			setUrlEditor(config.editor);
			fonte_padrao =  config.fontePadrao;
			setFontePadrao(fonte_padrao);
			return config.urlEditor;
		});

	} catch (error) {
		console.error('Error fetching data from API: getConfiguracaoEditor ', error);
		throw error;
	}
};


async function initializeUrlEditor() {
	try {
		const storedEditorUrl = localStorage.getItem('url_editor')
		url_editor = storedEditorUrl || (await getEditorUrl());
		setUrlEditor(url_editor);
		console.log('url_editor:', url_editor);
		return url_editor;
	} catch (error) {
		console.error('Error initializing URL editor:', error);
		throw error;
	}
}

export function carregarDadosEditorLocalStorage() {
	initializeUrlEditor().then((url_editor) => {
		url_editor = getUrlEditor();
		console.log('carregando dados do editor', url_editor);

	})
	.catch((error) => {
		console.error('erro ao carregaro dados do editor', error);
	});
}

export const localeOptions = [
	{ id: 'es', flag: 'es', name: <IntlMessage id="dashboards.general.es" />, direction: 'ltr' },
	{ id: 'en', flag: 'us', name: <IntlMessage id="dashboards.general.en" />, direction: 'ltr' },
	{ id: 'pt-br', flag: 'br', name: <IntlMessage id="dashboards.general.pt" />, direction: 'ltr' },
];

url_editor = getUrlEditor();

export const defaultLocale = process.env.REACT_APP_LANG;
export const name = process.env.REACT_APP_NAME;
export const version = process.env.REACT_APP_VERSION;
export const apiUrl = process.env.REACT_APP_URL_API;
export const editorUrl = url_editor;
export const editorRunat = process.env.REACT_APP_RUNAT_EDITOR;
export const editorPath = process.env.REACT_APP_PATH_EDITOR;
export const development = process.env.REACT_APP_DEVELOPMENT === 'true';
export const homolog = process.env.REACT_APP_HML === 'true';
export const homepage = process.env.REACT_APP_HOMEPAGE;
export const versionSystem = process.env.REACT_APP_VERSION_SYSTEM;


// WEBPACK FOOTER //
// ./src/constants/defaultValues.js